<template>
  <div @click="startEditing" class="editable-text">
    <span v-if="isEditing">
      <b-form-input
        id="input-lg"
        size="lg"
        maxlength="50"
        v-model="editText"
        ref="input"
        @blur="save"
        @keydown.enter="save"
        @keydown.esc="cancel"
        style="width: 15ch"
      />
    </span>

    <span v-else class="editable-text-label">
      {{ value }}
    </span>
  </div>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'EditableText',
  components: {
    BFormGroup,
    BFormInput
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isEditing: false,
      editText: this.value
    }
  },
  watch: {
    value(newVal) {
      this.editText = newVal
    }
  },
  methods: {
    startEditing() {
      if (!this.isEditing) {
        this.isEditing = true
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },
    save() {
      this.isEditing = false
      this.$emit('input', this.editText)
    },
    cancel() {
      this.isEditing = false
      this.editText = this.value
    }
  }
}
</script>

<style scoped>
.editable-text-label {
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 2rem; /* Match Bootstrap 'lg' input */
  width: 15ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
